module.exports = __webpack_public_path__ + "static/assets/d929b69b682c253fa0d8e6ed6cb3dbad.png";